import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Listens to changes in focus on the {@link Document}
 */
export const registerNewActiveElement = store.effects.create(
  (feature: Feature) =>
    new rxjs.Observable(subscriber => {
      function handleFocusIn(event: FocusEvent) {
        const element = event.target
        if (!element || element instanceof Element) {
          subscriber.next(
            feature.actions.registerNewActiveElement
              .from('registerNewActiveElement')
              .create(() => element),
          )
        }
      }
      document.addEventListener('focusin', handleFocusIn)
      return {
        unsubscribe() {
          document.removeEventListener('focusin', handleFocusIn)
        },
      }
    }),
)
